import LandingPage from "./pages/user/landing-page/landing-page";


function App() {
  
  

  return (
    <>
      <LandingPage />
    </>
  );
}

export default App;
